import {ScanRepository, UpdateDeliveryRequest} from '../repositories/ScanRepository';
import {Delivery} from '../entities/Delivery';

export class UpdateDeliveryUseCase {
  constructor(private readonly scanRepository: ScanRepository) {}

  async execute(request: UpdateDeliveryRequest): Promise<Delivery> {
    return await this.scanRepository.updateDelivery(request);
  }
}
